import { Alert, Button, Modal, Tag, message } from "antd";
import Skeleton from "components/_storybooks/Skeleton";
import { useProjectTypePermissions } from "features/ProjectType/data/hooks";
import { parseApiError } from "features/ProjectType/data/apiAdapters";
import Page403 from "pages/PageError/403";

export function ProjectTypeGuard({ children }) {
  const { canConfigure, loading } = useProjectTypePermissions();
  if (loading) return <Skeleton rows={5} />;
  if (!canConfigure) return <Page403 />;
  return children;
}
export function ProjectTypeState({ loading, data, error, refetch, children }) {
  if (error?.code === "FORBIDDEN") return <Page403 />;
  if (error) return <Alert type="error" message={error.message} action={<Button onClick={refetch}>Thử lại</Button>} />;
  if (loading && !data) return <Skeleton rows={5} />;
  return children;
}
export function VisibilityBadge({ visible }) {
  return (
    <Tag className={`project-type-badge ${visible ? "visible" : "hidden"}`}>
      {visible ? "Đang hiển thị" : "Đang ẩn"}
    </Tag>
  );
}
export const confirmHide = (onOk) =>
  Modal.confirm({
    title: "Ẩn loại dự án khỏi app? Phiếu cũ giữ nguyên.",
    okText: "Ẩn khỏi app",
    cancelText: "Hủy",
    onOk,
  });
export function showProjectTypeError(error) {
  const parsed = parseApiError(error);
  message.error(parsed.code === "PACKAGE_TIER_ALREADY_VISIBLE" ? "Mức này đã có gói đang hiển thị" : parsed.message);
}
export function setFormApiErrors(form, error) {
  const parsed = parseApiError(error);
  const fields =
    parsed.code === "PROJECT_TYPE_NAME_DUPLICATED" ? { name: "Tên loại dự án đã tồn tại" } : parsed.fieldErrors;
  form.setFields(
    Object.entries(fields)
      .filter(([field]) => field !== "icon")
      .map(([name, text]) => ({
        name: name.split(".").map((part) => (/^\d+$/.test(part) ? Number(part) : part)),
        errors: [text],
      }))
  );
  if (parsed.code === "PACKAGE_TIER_ALREADY_VISIBLE" || fields.icon || !Object.keys(fields).length)
    showProjectTypeError({ ...parsed, message: fields.icon || parsed.message });
}
